/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Players_Sort_PaymentInputs */



/**
* | output |
* | --- |
* | "Payment" |
*
* @param {Players_Sort_PaymentInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const players_sort_payment = /** @type {((inputs?: Players_Sort_PaymentInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Players_Sort_PaymentInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Paiement")
	if (locale === "es") return /** @type {LocalizedString} */ ("Pago")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Pagamento")
	if (locale === "it") return /** @type {LocalizedString} */ ("Pagamento")
	return /** @type {LocalizedString} */ ("Payment")
});